import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const container: SxStyleFunc<string | undefined> = (color) => ({
  position: 'relative',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: color || ((p) => p.palette.primary[100]),
  borderBottomWidth: 0,
  display: 'inline-flex',
  height: '100%',
  ml: (p) => p.spacing(11),
  mt: (p) => p.spacing(1.5),
  borderRadius: (p) => p.spacing(1, 1, 0, 0),
});

export const logo: SxStyle = {
  width: (p) => p.spacing(3.5),
  height: (p) => p.spacing(3.5),
  background: (p) => p.palette.success[100],
  borderRadius: (p) => p.spacing(1),
};

export const logoContainer: SxStyle = {
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: (p) => p.palette.grey[200],
  p: (p) => p.spacing(2, 1),
};

export const menu: SxStyle = {
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: (p) => p.palette.grey[200],
  padding: (p) => p.spacing(0.75, 1),
};

export const menuIcon: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[200],
  width: (p) => p.spacing(4.5),
  height: (p) => p.spacing(4.5),
  borderRadius: (p) => p.spacing(1),
};

export const icon: SxStyleFunc<string | undefined> = (color) => ({
  position: 'absolute',
  left: (p) => p.spacing(-1.5),
  color: color || ((p) => p.palette.primary[500]),
});

export const badge: SxStyleFunc<string | undefined> = (color) => ({
  background: color || ((p) => p.palette.primary[500]),
});
